import React from 'react';
import { useIntl } from 'react-intl';
import { StyledDescription } from 'Core_Pages/Screening/Results/styles';
import { ScreeningModuleStore } from 'Core_Pages/Screening/ScreeningModuleStore';
import { Screenings } from 'Core_Pages/Screening/enumerations/enums';
import { responseIndicators } from './config';

const screeningGuid = Screenings.ADULT_EPDS;

const Description = () => {
  const intl = useIntl();
  const screeningStore = ScreeningModuleStore.Instance().Use();
  const result = screeningStore.ScreeningResults.find((x) => x.screeningGuid === screeningGuid);

  const hasUrgentNeed = result?.subScores.some(
    (x) => x.responseIndicator === responseIndicators.POSTPARTUM_DEPRESSION && x.hasUrgentNeed,
  );

  const messageId = hasUrgentNeed
    ? 'screenings.results.adult.epds.description.urgent'
    : 'screenings.results.adult.epds.description.normal';

  return (
    <StyledDescription id="results-description" fontSize={18} fontWeight={700} color="white" paddingBottom={'20px'}>
      {intl.formatMessage({ id: messageId })}
    </StyledDescription>
  );
};

export default Description;
